/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import FIELD_TYPE from 'Component/Field/Field.config';
import Loader from 'Component/Loader';
import Popup from 'Component/Popup';

import PostNordPoint from '../PostNordPoint';
import { POST_NORD_POPUP_ID } from './PostNord.config';

import './PostNord.style';

/** @namespace Bodymod/PostNord/Component/PostNord/Component */
export class PostNordComponent extends PureComponent {
    static propTypes = {
        showPostNordPopUp: PropTypes.func.isRequired,
        point: PropTypes.object.isRequired,
        points: PropTypes.array.isRequired,
        postcode: PropTypes.string.isRequired,
        onPostCodeChange: PropTypes.func.isRequired,
        onStreetChange: PropTypes.func.isRequired,
        customPostCode: PropTypes.string.isRequired,
        customStreet: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isPointLoading: PropTypes.bool.isRequired,
        setPointLoading: PropTypes.func.isRequired,
        setSelectedPostNordPoint: PropTypes.func.isRequired,
        // eslint-disable-next-line react/boolean-prop-naming
        hasError: PropTypes.bool.isRequired
    };

    renderPoint = this.renderPoint.bind(this);

    renderPostNordPoint() {
        const {
            point: {
                name, zip, city, id
            }
        } = this.props;

        if (id) {
            return (
                <div mix={ { block: 'PostNord', elem: 'Description' } }>
                    <p mix={ { block: 'PostNord', elem: 'Title' } }>{ __('Pickup point') }</p>
                    <p>{ `${name}, ${zip}, ${city}, ID: ${id}` }</p>
                </div>
            );
        }

        return null;
    }

    renderPopUpOverlayFallback() {
        return <Loader isLoading />;
    }

    renderPopUp() {
        const { points, isPointLoading } = this.props;
        const loader = isPointLoading ? this.renderPopUpOverlayFallback() : null;
        return (
            <Popup
              id={ POST_NORD_POPUP_ID }
              mix={ { block: 'PostNordPopup' } }
            >
                { loader }
                <ul>
                    { points.map(this.renderPoint) }
                </ul>
            </Popup>
        );
    }

    renderPoint(point) {
        const { setPointLoading, setSelectedPostNordPoint } = this.props;
        return (
            <PostNordPoint
              point={ point }
              setPointLoading={ setPointLoading }
              setSelectedPostNordPoint={ setSelectedPostNordPoint }
            />
        );
    }

    renderError() {
        const { hasError } = this.props;
        if (hasError) {
            return (
                <div block="Field" elem="ErrorMessages">
                    <div block="Field" elem="ErrorMessage">
                        { __('This field is required!') }
                    </div>
                </div>
            );
        }

        return null;
    }

    renderPostNordFields() {
        const {
            postcode, onPostCodeChange, customPostCode, customStreet, street, onStreetChange, hasError
        } = this.props;
        const renderPostNordPoint = this.renderPostNordPoint.bind(this);
        const type_text = true;
        return (
            <div block="FieldGroup">
                    <div
                      mix={ {
                          block: 'Field',
                          mods: { hasError, type_text }
                      } }
                    >
                        <div block="Field" elem="LabelContainer">
                            <label block="Field" elem="Label" htmlFor="postcode">
                                { __('ZIP') }
                            </label>
                        </div>
                        <input
                          type={ FIELD_TYPE.text }
                          value={ customPostCode || postcode }
                          placeholder={ __('ZIP') }
                          aria-label={ __('ZIP') }
                          name="postcode"
                          id="postcode"
                          onChange={ onPostCodeChange }
                        />
                        { this.renderError() }
                    </div>
                <div
                  mix={ {
                      block: 'Field',
                      mods: { type_text }
                  } }
                >
                        <div block="Field" elem="LabelContainer">
                            <label block="Field" elem="Label" htmlFor="street">
                                { __('Street') }
                            </label>
                        </div>
                        <input
                          type={ FIELD_TYPE.text }
                          value={ customStreet || street }
                          placeholder={ __('Street') }
                          aria-label={ __('Street') }
                          name="street"
                          id="street"
                          onChange={ onStreetChange }
                        />
                </div>
                { renderPostNordPoint }
            </div>
        );
    }

    render() {
        const { showPostNordPopUp, point: { name }, isLoading } = this.props;
        const buttonLabel = name ? __('Change pickup point') : __('Find pickup point');
        const loader = isLoading ? this.renderPopUpOverlayFallback() : null;
        const popUp = !isLoading ? this.renderPopUp() : null;
        return (
            <div block="PostNord">
                { loader }
                { this.renderPostNordFields() }
                { this.renderPostNordPoint() }
                <button
                  block="Button"
                  type={ FIELD_TYPE.button }
                  mods={ { isHollow: false } }
                  onClick={ showPostNordPopUp }
                  mix={ { block: 'PostNord', elem: 'Button' } }
                >
                        { buttonLabel }
                </button>
                { popUp }
            </div>
        );
    }
}

export default PostNordComponent;
